/* --external-- */
import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import classnames from "classnames";
import { ButtonDisclosure, Dropdown, DropdownMenu } from "@toddle-edu/ds-web";

/* --internal-- */
import { DEFAULT_MEDIA_SUBMISSION_METHOD } from "Worksheet/modules/WorksheetConstants";

/* --relative-- */
import classes from "./MediaQuestionSubmissionMethod.scss";

const MediaQuestionSubmissionMethod = props => {
  const {
    value,
    fieldKey,
    updateInputField,
    t,
    questionTypeUid,
    options,
    labelConfig,
  } = props;

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const submissionMethods = useMemo(() => {
    return _.map(options, option => ({
      label: t(_.get(option, "labelLocale", "")),
      key: _.get(option, "key", ""),
    }));
  }, [options, t]);

  /**
   * Handles the change of submission method.
   * @param {string} method - The selected submission method key.
   */
  const handleMethodChange = React.useCallback(
    method => {
      const modifiedValue = {
        [fieldKey]: method,
      };

      updateInputField({ params: modifiedValue, isDebounce: true });
    },
    [fieldKey, updateInputField]
  );

  useEffect(() => {
    if (value) return;
    handleMethodChange(DEFAULT_MEDIA_SUBMISSION_METHOD);
  }, [value, handleMethodChange]);

  const submissionMethodLabel = useMemo(() => {
    const method = _.find(submissionMethods, { key: value });
    return _.get(method, "label", "");
  }, [submissionMethods, value]);

  const labelLocale = _.get(labelConfig, "labelLocale", "");
  const labelClasses = classnames("text-body-1", classes.label);

  const testId = `worksheet-${questionTypeUid}-questionType-methodDropdown`;

  return (
    <div className={classes.container}>
      <div className={labelClasses}>{t(labelLocale)}</div>
      <Dropdown
        dsVersion="2.0"
        visible={isDropdownVisible}
        onVisibleChange={setIsDropdownVisible}
        overlay={
          <DropdownMenu
            options={submissionMethods}
            onClick={e => handleMethodChange(e.key)}
            testId={testId}
          />
        }
      >
        <ButtonDisclosure
          testId={testId}
          dsVersion="2.0"
          variant="neutral"
          type="outlined"
          isFullWidth={true}
          className={classes.dropdownButton}
        >
          {submissionMethodLabel}
        </ButtonDisclosure>
      </Dropdown>
    </div>
  );
};

export default MediaQuestionSubmissionMethod;
